import { Dispatch } from 'redux';

import * as Actions from '../actions/assessmentResult';
import AbstractScenario from './AbstractScenario';

const keyAssessmentResultData = 'per_skill_AssessmentResultDataModel';

export default class AssessmentResultScenarioFactory {
	/**
	 * アセスメント結果データを取得する。
	 *
	 * @param dispatch dispatch
	 * @param token token
	 */
	public static getAssessmentResultData(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process(jouken: any) {
				return this.read(keyAssessmentResultData, {
					...jouken,
					accessType: 10,
				}).then(data => {
					this.dispatch(
						Actions.setAssessmentResultData({
							assessmentResultList: data.assessmentResultList,
							averageFlg: data.averageFlg,
							careerName: data.careerName,
							categoryFlg: data.categoryFlg,
							comment: data.comment,
							rankName: data.rankName,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/AssessmentResultScenarioFactory.ts